import { render, staticRenderFns } from "./reservationDetail.vue?vue&type=template&id=592bdcc8"
import script from "./reservationDetail.vue?vue&type=script&lang=js"
export * from "./reservationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports